import { r as o, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const e = ".sc-arrow-icon-h{display:flex}", c = e, s = class {
  constructor(r) {
    o(this, r), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "fed9a45c6880d6cfefba5d70ab0e0c3f0e6c5c5c", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "cf58d5ba2c49aac7bb558c7f5c823773cf2c669e", d: "M5 12H19M12 5L19 12L12 19", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
};
s.style = c;
export {
  s as arrow_icon
};
